<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/laptop_lock.jpg');
            background-position: top !important;
          "
        ></div>
        <!-- <img src="/static/img/video-main-banner.svg" /> -->
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5" v-if="editMode">
              {{ $t("edit_tenant") }}
            </div>
            <div class="text-subtitle-2 text-md-h5" v-else>
              {{ $t("create_tenant") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb v-if="!editMode" />
    <Breadcrumb v-else :trainingNameEdit="tenant.name" />
    <div class="pt-8">
      <div class="mx-0 row disablerow align-items-start">
        <!-- Left Area -->
        <div class="col-xl-9 innercreatetraining px-md-12 px-8 pr-sm-16">
          <div class="mx-0 pa-0 text-content">
            <div class="row disablerow justify-content-between">
              <div class="col-md-6 disablerow">
                <div class="col-md-12 pt-0 margin-wrapper">
                  <span class="headlinecolor text-h6">
                    {{ $t("general") }}</span
                  >
                </div>
                <div class="col-sm-12 col-md-12">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('designation') + '*'"
                    @keypress.enter="saveTenant()"
                    v-model="tenant.name"
                  ></v-text-field>
                </div>
                <div class="col-sm-12 col-md-12">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('sortNumber')"
                    @keypress.enter="saveTenant()"
                    v-model="tenant.sortNumber"
                  ></v-text-field>
                </div>
                <div class="col-sm-12 col-md-12 pt-0 create-tenant-customer">
                  <v-checkbox
                    v-model="tenant.customer"
                    :disabled="!allowedToCreateKBTenants"
                    class="no-margin-top"
                    :label="$t('customer')"
                  ></v-checkbox>
                </div>
              </div>

              <div class="col-md-6 row disablerow">
                <div class="col-md-12 pt-0 margin-wrapper">
                  <span class="headlinecolor text-h6">
                    {{ $t("address") }}</span
                  >
                </div>
                <div class="col-sm-10 col-md-10">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('street') + '*'"
                    v-model="tenant.street"
                  ></v-text-field>
                </div>
                <div class="col-12 col-sm-2 col-md-2 pl-sm-0">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('number') + '*'"
                    v-model="tenant.hnr"
                  ></v-text-field>
                </div>
                <div class="col-sm-4 col-md-3 pr-sm-0">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('postal code') + '*'"
                    v-model="tenant.zip"
                  ></v-text-field>
                </div>
                <div class="col-sm-8 col-md-9">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('location') + '*'"
                    v-model="tenant.city"
                  ></v-text-field>
                </div>
                <div class="col-sm-12 col-md-12">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('debitor')"
                    v-model="tenant.debitor"
                  ></v-text-field>
                </div>

                <div class="col-sm-12 col-md-12">
                  <v-select
                    hide-details="auto"
                    :items="sortedCountries"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('country') + '*'"
                    v-model="tenant.country"
                  ></v-select>
                </div>
              </div>
            </div>
            <div class="col-md-12 lastBtnSubmit mr-0 ml-0">
              <v-btn
                v-if="!editMode"
                @click="saveTenant()"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
                v-show="$rights.includes('CREATE_CUSTOMERS')"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                v-else
                @click="saveTenant()"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
                v-show="$rights.includes('EDIT_CUSTOMERS')"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                v-show="editMode && $rights.includes('DELETE_CUSTOMERS')"
                @click="openDeleteDialog = true"
                outlined
                depressed
                tile
                class="deletebutton cancelBtn mr-2 mb-2"
              >
                <v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
            </div>

            <!--  -->
            <div class="text-center">
              <v-dialog v-model="openDeleteDialog" width="500">
                <h4 v-if="tenant.tenantAssign == true">
                  {{ $t("confirm_tenant_deleted") }}
                </h4>
                <h4 v-else>{{ $t("delete_tenat") }}</h4>
                <v-card-actions>
                  <v-spacer></v-spacer>

                  <v-btn
                    @click="openDeleteDialog = false"
                    outlined
                    depressed
                    tile
                    class="cancelbutton cancelBtn mr-2 mb-2"
                  >
                    {{ $t("cancel") }}</v-btn
                  >
                  <v-btn
                    v-show="editMode && $rights.includes('DELETE_CUSTOMERS')"
                    @click="deleteTenant()"
                    outlined
                    depressed
                    tile
                    class="savebutton mr-2 mb-2"
                  >
                    <img
                      src="/static/img/popup-delete-icon.svg"
                      class="popup-delete-icon"
                    />
                    {{ $t("delete") }}</v-btn
                  >
                </v-card-actions>
              </v-dialog>
            </div>
            <!--  -->
            <div class="text-right">
              <v-label> * {{ $t("mandatory_fields") }} </v-label>
            </div>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 px-0 pl-8 pl-md-12 row pt-0 onlyContact">
          <div class="col-xl-12 right-side-block hide">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              :to="`/tenants`"
              outlined
              depressed
              tile
              class="backbutton mr-2 mb-2"
            >
              <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
            >
            <v-btn
              v-if="!editMode"
              @click="saveTenant()"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              v-show="$rights.includes('CREATE_CUSTOMERS')"
              >{{ $t("save") }}</v-btn
            >
            <v-btn
              v-else
              @click="saveTenant()"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              v-show="$rights.includes('EDIT_CUSTOMERS')"
              >{{ $t("save") }}</v-btn
            >

            <v-btn
              v-show="editMode && $rights.includes('DELETE_CUSTOMERS')"
              @click="deleteTenant()"
              outlined
              depressed
              tile
              class="deletebutton mr-2 mb-2"
            >
              <v-icon color="#444">mdi-delete</v-icon> {{ $t("delete") }}</v-btn
            >
          </div>
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Breadcrumb,
  },
  props: {
    tenantId: Number,
  },

  data() {
    return {
      positiveNumberRule: (value) => {
        return value >= 0 || this.$t("Please_Enter_number");
      },
      countries: [],
      editMode: false,
      openDeleteDialog: false,
      allowedToCreateKBTenants: false,

      tenant: {
        name: null,
        customer: false,
        hnr: null,
        street: null,
        zip: null,
        city: null,
        country: null,
        debitor: null,
        sortNumber: null,
      },
    };
  },

  computed: {
    sortedCountries() {
      return this.countries
        .map((country) => ({
          text: this.$t(country),
          value: country,
        }))
        .sort((a, b) => (a.text > b.text ? 1 : b.text > a.text ? -1 : 0));
    },
  },
  updated() {
    if (this.$rights.includes("TENANT_INDEPENDENCE")) {
      this.allowedToCreateKBTenants = true;
    } else {
      this.tenant.customer = true;
    }
  },

  mounted() {
    this.fetchCountries();

    if (this.tenantId != null) {
      this.editMode = true;
      this.fetchEditingTenant();
    }
  },

  methods: {
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },

    fetchCountries() {
      this.$axios
        .get("/api/location/allCountries")
        .then((response) => {
          this.countries = response.data;
        })
        .catch(this.onError);
    },

    fetchEditingTenant() {
      var _this = this;
      this.$axios
        .get("/api/tenant/" + this.tenantId)
        .then(function (response) {
          _this.tenant = response.data;
        })
        .catch(this.onError);
    },

    saveTenant() {
      var _this = this;
      var tenant = {};
      tenant = Object.assign(tenant, this.tenant);
      this.tenant.addressFormatted = null;
      this.tenant.addressFormattedSingleLine = null;
      this.tenant.addressFormattedSingleLineWithCountry = null;

      if (this.$isStringEmptyOrNull(tenant.name)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("designation") })
        );
        return;
      }

      if (this.$isStringEmptyOrNull(tenant.street)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("street") }));
        return;
      }

      if (this.$isStringEmptyOrNull(tenant.hnr)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("number") }));
        return;
      }

      const numberRegex = /^\d+$/;
      if (tenant.sortNumber && !numberRegex.test(tenant.sortNumber)) {
        this.$noty.error(
          this.$t("invalid_value", { name: this.$t("sortNumber") })
        );
        return;
      }

      if (this.$isStringEmptyOrNull(tenant.zip)) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("postal code") })
        );
        return;
      }

      if (this.$isStringEmptyOrNull(tenant.city)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("location") }));
        return;
      }

      if (this.$isStringEmptyOrNull(tenant.country)) {
        this.$noty.error(this.$t("empty_value", { name: this.$t("country") }));
        return;
      }

      if (this.editMode) {
        // Edit Training
        this.$axios
          .put("/api/tenant/" + this.tenantId, this.tenant)
          .then(function (response) {
            _this.$noty.success(
              _this.$t("tenant_edited", { name: response.data.name })
            );
            _this.$router.push("/tenants");
          })
          .catch(this.onError);
      } else {
        // Create new Training
        this.$axios
          .post("/api/tenant", this.tenant)
          .then(function (response) {
            _this.$noty.success(
              _this.$t("tenant_saved", { name: response.data.name })
            );
            _this.$router.push("/tenants");
          })
          .catch(this.onError);
      }
    },

    deleteTenant() {
      if (this.tenantId == null) {
        console.error("You are not editing an existing tenant.");
        return;
      }

      var _this = this;

      this.$axios
        .delete("/api/tenant/" + this.tenantId)
        .then(function (response) {
          _this.$noty.success(
            _this.$t("tenant_delete", { name: _this.tenant.name })
          );
          _this.$router.push("/tenants");
        })
        .catch(this.onError);
    },

    onFinally() {
      showLoadingCircle(false);
    },
  },
};
</script>
